import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './ParagraphSpacer.css';

function ParagraphSpacer() {
    const {t} = useTranslation('whatsapp');

    return (
        <css.spacer>
            <css.line />
            <css.text>{t('paragraphSpacer')}</css.text>
            <css.line />
        </css.spacer>
    );
}

export default ParagraphSpacer;
